// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Mainpage_main-container__2L4rE"};